import { gql } from '@apollo/client';

export const GET_DRIVER_START_END_ADDRESS = gql`
    query GetDriverStartEndAddress($request: GetDriverStartEndAddressRequestInput!) {
        getDriverStartEndAddress(request: $request) {
            driverId
            startAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
            endAddress {
                streetAddress
                unit
                city
                state
                zipCode
                county
                latitude
                longitude
            }
        }
    }
`;

export interface DriverAddressOutput {
    streetAddress?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    latitude?: number | null;
    longitude?: number | null;
}

export interface DriverStartEndAddressOutput {
    driverId?: number | null;
    startAddress?: DriverAddressOutput | null;
    endAddress?: DriverAddressOutput | null;
}

export interface GetDriverStartEndAddressRequestInput {
    driverId: number;
    warehouseId: number;
}

export interface GetDriverStartEndAddressResponse {
    getDriverStartEndAddress?: DriverStartEndAddressOutput | null;
}

export interface GetDriverStartEndAddressVariables {
    request: GetDriverStartEndAddressRequestInput;
}
